import { supabase } from '../lib/supabase';

export type Caderno = 'normal' | 'extra' | 'suplemento';

export const CADERNO_LABEL: Record<Caderno, string> = {
  normal: 'Edição normal',
  extra: 'Edição extra',
  suplemento: 'Suplemento',
};

export interface EdicaoListaItem {
  id: string;
  numero: string;
  titulo: string;
  data_publicacao: string | null;
  caderno: Caderno | null;
  atos_quantidade: number;
  publicada_em: string | null;
  pdf_url: string | null;
}

export interface AtoEdicao {
  id: string;
  numero_publicado: string | null;
  tipo_ato: string | null;
  titulo: string;
  ementa: string | null;
  corpo: string | null;
  autoridade_nome: string | null;
  autoridade_cargo: string | null;
  data_publicacao: string | null;
  revogado: boolean;
}

export interface EdicaoDetalhe {
  id: string;
  numero: string;
  titulo: string;
  data_publicacao: string | null;
  caderno: Caderno | null;
  publicada_em: string | null;
  pdf_url: string | null;
  pdf_gerado_em: string | null;
  estabelecimento_nome: string | null;
  atos: AtoEdicao[];
}

export const diariosOficiaisService = {
  async listar(estabelecimentoId: string, ano?: number): Promise<{ ano: number; edicoes: EdicaoListaItem[] }> {
    const { data, error } = await supabase.rpc('diarios_oficiais_listar_publicos', {
      p_estabelecimento_id: estabelecimentoId,
      p_ano: ano ?? null,
    });
    if (error) throw error;
    const r = data as { ano: number; edicoes: EdicaoListaItem[] };
    return { ano: r.ano, edicoes: r.edicoes ?? [] };
  },

  async buscar(documentoId: string): Promise<EdicaoDetalhe | { erro: string }> {
    const { data, error } = await supabase.rpc('diario_oficial_buscar_publico', {
      p_documento_id: documentoId,
    });
    if (error) throw error;
    return data as EdicaoDetalhe | { erro: string };
  },
};
